import { io } from 'socket.io-client';
import env from '../config/env';

// Instance unique partagée dans toute l'app — connexion manuelle via socket.connect()
const socket = io(env.baseUrlApi, { autoConnect: false });

export default socket;
